/* eslint-disable jsx-a11y/anchor-is-valid */
import  { FC, useEffect, useRef } from 'react'
import { StepperComponent } from '../../../assets/ts/components'

const Main: FC = () => {
  const stepperRef = useRef<HTMLDivElement | null>(null)
  const stepper = useRef<StepperComponent | null>(null)
  const loadStepper = () => {
    stepper.current = StepperComponent.createInsance(stepperRef.current as HTMLDivElement)
  }


  useEffect(() => {
    if (!stepperRef.current) {
      return
    }

    loadStepper()
  }, [stepperRef])

  return (
    <div className='modal fade' id='kt_modal_create_app' aria-hidden='true'>
    </div>
  )
}

export { Main }
